import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ArrowForwardColoredIcon: React.FC<CardGradientProps> = ({
  className,
  width = "17",
  height = "14",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 7.00024H2.25"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 2L14.75 7L9.75 12"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowForwardColoredIcon;
